import { render, staticRenderFns } from "./UpdateFutures.vue?vue&type=template&id=a5c65de4&scoped=true"
import script from "./UpdateFutures.vue?vue&type=script&lang=js"
export * from "./UpdateFutures.vue?vue&type=script&lang=js"
import style0 from "./UpdateFutures.vue?vue&type=style&index=0&id=a5c65de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c65de4",
  null
  
)

export default component.exports